import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_034",
  "use": "icon-wo_034-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_034\"><defs><style>#icon-wo_034 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_034_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_034_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"20 9 20 15 14 15 14 20 4 12 14 4 14 9 20 9\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol